import React, { useEffect, useMemo, useState } from 'react';
import * as PropTypes from 'prop-types';
import moment from 'utils/moment';
import ReactTableComponent from 'components/ReactTableComponent/ReactTableComponent';
import Spoiler from 'components/Spoiler/Spoiler';
import { cellFn } from './cellFn';
import { DetailsModal } from './DetailsModal';
import '../ArmyMobilizedSupport.module.scss';

const TABLE_PAGE_SIZE = 3;

export function ArmyMeasures(props) {
  const { dateToArmy, dateFromArmy, measures, persona = 'физического лица' } = props;

  const columns = [
    {
      Header: 'Документ, по которому предоставлена мера',
      accessor: 'actionDesc',
      width: 350,
      Cell: ({ value }) => cellFn(value),
    },
    {
      Header: 'Применяемая мера',
      width: 240,
      accessor: 'mobActionDesc',
      Cell: ({ value }) => cellFn(value),
    },
    {
      Header: 'Информация о новых сроках и суммах',
      accessor: 'deferredObligations',
      width: 330,
      Cell: ({ value }) => cellFn(value?.replaceAll('//', '\n')),
    },
    {
      Header: 'Детали',
      width: 80,
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => <DetailsModal {...row} />,
    },
  ];
  const [pagination, setPagination] = useState({
    number: 0,
  });
  const tableData = useMemo(() => {
    const { number } = pagination;

    const nMeasures = measures.slice(
      number * TABLE_PAGE_SIZE,
      number * TABLE_PAGE_SIZE + TABLE_PAGE_SIZE,
    );
    return nMeasures;
  }, [measures, pagination]);

  const fetchPage = ({ page }) => {
    setPagination({ ...pagination, number: page });
  };

  useEffect(() => {
    setPagination({
      number: 0,
      size: TABLE_PAGE_SIZE,
      totalPages: Math.ceil(measures.length / TABLE_PAGE_SIZE),
    });
  }, [measures]);

  return (
    <Spoiler
      theme={'white'}
      btnPosition={'right'}
      unmountOnHide={true}
      title={
        <div>
          <h4 style={{ color: '#1976d2' }}>
            Перечень мер для {persona}, мобилизованного
            {dateToArmy ? ' с ' + moment.fromServerDatetime(dateToArmy).format('DD.MM.YYYY') : null}
            {dateFromArmy
              ? ' по ' + moment.fromServerDatetime(dateFromArmy).format('DD.MM.YYYY')
              : null}
          </h4>
        </div>
      }
    >
      <ReactTableComponent
        columns={columns}
        tableData={tableData}
        paginationOptions={pagination.totalPages > 1 ? pagination : null}
        fetchNextPage={fetchPage}
        isLoading={false}
        rowLimit={TABLE_PAGE_SIZE}
        theme={'blue'}
      />
    </Spoiler>
  );
}

ArmyMeasures.propTypes = {
  dateToArmy: PropTypes.string,
  dateFromArmy: PropTypes.string,
  measures: PropTypes.arrayOf(PropTypes.object),
  persona: PropTypes.string,
};
